import { Box, SxProps, Theme } from '@mui/material';
import React, { FC, ReactNode } from 'react';

interface ContainerBoxProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

const ContainerBox: FC<ContainerBoxProps> = ({ children, sx }) => {
  return (
    <Box
      sx={{
        backgroundColor: (theme) => theme.palette.background.paper,
        height: 'fit-content',
        width: '100%',
        borderRadius: '8px',
        border: (theme) => `1px solid ${theme.palette.divider}`,
        overflow: 'hidden',
        padding: '12px',
        ...sx,
      }}>
      {children}
    </Box>
  );
};

export default ContainerBox;
